import React, {useEffect, useState} from 'react';
import JsonData from "./data/data.json";
import {Navigation} from "./components/navigation";
import {Header} from "./components/header";
import {Features} from "./components/features";
import {About} from "./components/about";
import {Services} from "./components/services";
import {Gallery} from "./components/gallery";
import {Testimonials} from "./components/testimonials";
import {Team} from "./components/Team";
import {Contact} from "./components/contact";
import SmoothScroll from "smooth-scroll";
import {BaseStyle} from "../../styles/shared/BaseStyle";
// import "./style/style.css";


export const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
});

const LandingPage2 = () => {
    const classes = BaseStyle();
    const [landingPageData, setLandingPageData] = useState({});
    useEffect(() => {
        setLandingPageData(JsonData);
    }, []);

    const [stylesLoaded, setStylesLoaded] = useState(false);

    useEffect(() => {
        if (!stylesLoaded) {
            import("./style/style.css").then(() => setStylesLoaded(true));
        }
    }, [stylesLoaded]);

    return (
        <React.Fragment>
            {stylesLoaded && <React.Fragment>
                <Navigation/>

                <Header data={landingPageData.Header}/>
                <Features data={landingPageData.Features}/>
                <About data={landingPageData.About}/>
                <Services data={landingPageData.Services}/>
                {/*<Gallery data={landingPageData.Gallery}/>*/}
                <Testimonials data={landingPageData.Testimonials}/>
                {/*<Team data={landingPageData.Team}/>*/}
                <Contact data={landingPageData.Contact}/>

            </React.Fragment>}


        </React.Fragment>
    );
};


export default React.memo(LandingPage2);
